import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText } from '@mui/material';

import { legendLabels } from 'src/components/dashboard/DashboardPage/widgets/StackedBarWidget/index';

import { styles } from './index.styles';

const StackedBarLegend: FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <List
      className="StackedBarLegend-root"
      data-test-id="StackedBarLegendRoot"
      sx={styles.StackedBarLegend}
    >
      {legendLabels.map((legendLabel, index) => (
        <ListItem disablePadding key={legendLabel} sx={styles.listItem(index)}>
          <ListItemText primary={t(`Answers.${legendLabel}`)} />
        </ListItem>
      ))}
    </List>
  );
};

export default StackedBarLegend;
